import { useState } from "react";
import { Card, CardContent, Button } from "./UI";
import { FileText, Shield, ExternalLink } from "lucide-react";
import { PrivacyPolicyPage, TermsOfUsePage } from "../ProfileCard";

export function LegalSection() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  if (showPrivacy) {
    return <PrivacyPolicyPage onBack={() => setShowPrivacy(false)} />;
  }

  if (showTerms) {
    return (
      <TermsOfUsePage
        onBack={() => setShowTerms(false)}
        onSwitchToPrivacy={() => {
          setShowTerms(false);
          setShowPrivacy(true);
        }}
      />
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-primary-text">Legal</h2>
        <p className="text-text-gray mt-1">Review our policies and terms.</p>
      </div>

      <Card className="border-sm-border/50 shadow-sm">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-sm-primary/10">
              <Shield className="h-6 w-6 text-sm-primary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-primary-text">Privacy Policy</h3>
              <p className="text-sm text-text-gray mt-1">
                Learn how we collect, use, and protect your personal information. Your privacy matters to us.
              </p>
              <p className="text-xs text-text-gray mt-2">Last updated: December 15, 2024</p>
              <Button
                variant="outline"
                className="mt-4 gap-2"
                onClick={() => setShowPrivacy(true)}
              >
                <FileText className="h-4 w-4" />
                Read Privacy Policy
                <ExternalLink className="h-3 w-3" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="border-sm-border/50 shadow-sm">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-sm-secondary/10">
              <FileText className="h-6 w-6 text-sm-secondary" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-primary-text">Terms of Service</h3>
              <p className="text-sm text-text-gray mt-1">
                The rules and guidelines for using SiteMaster. By using our platform, you agree to these terms.
              </p>
              <p className="text-xs text-text-gray mt-2">Last updated: December 10, 2024</p>
              <Button
                variant="outline"
                className="mt-4 gap-2"
                onClick={() => setShowTerms(true)}
              >
                <FileText className="h-4 w-4" />
                Read Terms of Service
                <ExternalLink className="h-3 w-3" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* <Card className="border-sm-border/50 shadow-sm">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-sm-accent/10">
              <FileText className="h-6 w-6 text-sm-accent" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-primary-text">Cookie Policy</h3>
              <p className="text-sm text-text-gray mt-1">
                Information about how we use cookies and similar technologies on our platform.
              </p>
              <p className="text-xs text-text-gray mt-2">Last updated: November 28, 2024</p>
              <Button variant="outline" className="mt-4 gap-2">
                <FileText className="h-4 w-4" />
                Read Cookie Policy
                <ExternalLink className="h-3 w-3" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card> */}

      <div className="text-center py-4">
        <p className="text-sm text-text-gray">
          Questions about our policies?{" "}
          <a href="mailto:legal@sitemaster.in" className="text-sm-primary hover:underline">
            Contact our legal team
          </a>
        </p>
      </div>
    </div>
  );
}
